import './public-path'; // must be first: sets webpack publicPath for chunks
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { sendHeartbeat } from './heartbeat';

function mountWidget() {
  const mountEl = document.getElementById('sigil-chatbot');
  if (!mountEl) {
    return;
  }

  // Editable copy + extras come from wp_localize_script (window.cmwChatConfig);
  // URLs/nonce also live on the mount element's data attributes as a fallback.
  const wpConfig = (typeof window !== 'undefined' && window.cmwChatConfig) || {};

  // Prefer the new cmw/v1/chat endpoint; fall back to the legacy prompt route.
  const restConfig = {
    url: mountEl.dataset.cmwUrl || wpConfig.url || mountEl.dataset.restUrl || '/wp-json/cmw/v1/chat',
    heartbeatUrl: mountEl.dataset.heartbeatUrl || wpConfig.heartbeatUrl || '',
    nonce: mountEl.dataset.restNonce || wpConfig.nonce || '',
    welcomeMessage: wpConfig.welcomeMessage || '',
    introMessage: wpConfig.introMessage || '',
    disclaimer: wpConfig.disclaimer || '',
    buttonIconUrl: wpConfig.buttonIconUrl || mountEl.dataset.buttonIconUrl || '',
    initialQuestions: Array.isArray(wpConfig.initialQuestions) ? wpConfig.initialQuestions : [],
    // wp_localize_script stringifies scalars, so coerce numeric strings ("24").
    welcomeResetHours: Number.isFinite(parseInt(wpConfig.welcomeResetHours, 10))
      ? parseInt(wpConfig.welcomeResetHours, 10)
      : 24,
  };

  try {
    const root = ReactDOM.createRoot(mountEl);
    root.render(
      <React.StrictMode>
        <App restConfig={restConfig} />
      </React.StrictMode>
    );
    // Visitor heartbeat: report a successful mount.
    sendHeartbeat(restConfig, 'mounted');
  } catch (error) {
    // Report a caught mount error so the widget-health pill can flag it.
    sendHeartbeat(restConfig, 'error', error?.message || 'mount failed');
  }
}

// The mount <div> is printed late in wp_footer (after this script may execute),
// so wait for the DOM if it isn't there yet.
if (document.getElementById('sigil-chatbot')) {
  mountWidget();
} else if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mountWidget);
} else {
  // DOM is ready but the element still isn't present — try once more next tick.
  setTimeout(mountWidget, 0);
}
